import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type DrawerCloseHandlers = {
	close: (value?: any) => void;
	cancel: (value?: any) => void;
	callback: (value?: any) => void;
};

type State = {
	drawerCloseHandlers: DrawerCloseHandlers;
};

type Actions = {
	updateDrawerCloseHandlers: (data: DrawerCloseHandlers) => void;
};

export type DeleteConfirmationModalState = State & Actions;

const initialState = {
	drawerCloseHandlers: null,
};

export const createDrawerCloseHandlerSlice: StateCreator<DeleteConfirmationModalState> = (
	set,
	get
) => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		updateDrawerCloseHandlers: (data: DrawerCloseHandlers) => {
			const { drawerCloseHandlers } = get();

			if (!data) {
				set({
					drawerCloseHandlers: null,
				});
			} else {
				set({
					drawerCloseHandlers: { ...drawerCloseHandlers, ...data },
				});
			}
		},
	};
};
